import React, { useContext, useEffect } from 'react';
import useAccount from '@/hooks/useAccount';
import { languageContext } from '@/context/language.context';
import { initBeacon, renderHelpScout } from '@/utils/utils';
import { SolutionContext } from '@/context/solution.context';
import { viewportContext } from '@/context/viewport.context';

const Botlist = [
  'Googlebot',
  'Google-InspectionTool',
  'Pingdom',
  'Crawler',
  'YandexBot',
  'EasouSpider',
  'MJ12bot',
  'XoviBot',
  'Slurp',
  'bingbot',
  'Baiduspider',
  'Facebook',
  'Yandex',
  'Twitter'
];

// add 'staging' or 'development' to the array to see the chat box in the respective environment
const activeEnvironments = ['production'];

const BeaconInner = () => {
  const { solution } = useContext(SolutionContext);
  const { account } = useAccount();
  const { currentLanguage } = useContext(languageContext);

  const checkProStatus = () => {
    return account?.data?.is_professional || false;
  };

  // Do not display on Family Resource Finder
  const isFRF = () => window.location.pathname.includes('familyresourcefinder');

  useEffect(() => {
    if (
      !solution.beacon?.enabled ||
      !activeEnvironments.includes(process.env.NODE_ENV) ||
      isFRF() ||
      navigator.userAgent.toLowerCase().match(new RegExp(Botlist.join('|').toLowerCase()))
    ) {
      return;
    }

    initBeacon();
    const isPro = checkProStatus();
    let timeoutId;
    if (isPro) {
      timeoutId = renderHelpScout('pro');
    } else {
      timeoutId = renderHelpScout(currentLanguage);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [account?.data?.is_professional, solution.beacon?.enabled, currentLanguage]);

  return <></>;
};

const Beacon = () => {
  const { isMobile, viewportWidth } = useContext(viewportContext);

  // Hide the beacon button with CSS on mobile instead of calling Beacon('destroy'),
  // which leaves the HelpScout SDK unable to re-init on future desktop resizes.
  useEffect(() => {
    if (!isMobile) return;
    const style = document.createElement('style');
    style.dataset.beaconMobileHide = 'true';
    style.textContent = '#beacon-container { display: none !important; }';
    document.head.appendChild(style);
    return () => style.remove();
  }, [isMobile]);

  return viewportWidth > 0 && !isMobile ? <BeaconInner /> : null;
};

export default Beacon;
